import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "N S Solution";
const SITE_URL = "https://nssolution.net";
const DEFAULT_TITLE =
  "HVAC Distributor in Surat | N S Solution";
const DEFAULT_DESCRIPTION =
  "N S Solution is an authorized distributor, dealer, stockist and importer of leading HVAC, plumbing and firefighting brands. Quality products and timely delivery from Surat, India.";
const DEFAULT_IMAGE = `${SITE_URL}/text-logo.png`;
const DEFAULT_IMAGE_ALT = "N S Solution logo";

/**
 * Reusable SEO head manager.
 * Renders <title>, meta description, canonical, robots and
 * Open Graph / Twitter Card tags. Any prop is optional and falls back
 * to sensible site-wide defaults. Pages can render their own <Seo>
 * to override the route-level defaults (helmet-async is last-write-wins).
 */
export default function Seo({
  title,
  description,
  path,
  image,
  imageAlt = DEFAULT_IMAGE_ALT,
  type = "website",
  noindex = false,
}) {
  const fullTitle = title
    ? title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`
    : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = `${SITE_URL}${
    path != null
      ? path
      : typeof window !== "undefined"
      ? window.location.pathname
      : "/"
  }`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  );
}
